<template>
  <v-app>
    <v-main class="main-bg">

      <!-- HERO / BANNER -->
      <Header :event-details="event" :hide-subtitle="true" />
      <v-container>
        <div class="text-center">
          <h1 class="text-uppercase font-dm-serif"><span class="primary--text">Choose your </span><span
              class="gold--text">passport</span></h1>
          <p class="primary--text">Join us in creating unforgettable memories and meaningful connections.</p>
        </div>

        <div class="max-w-1200 m-0-auto">
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-card class="pa-5">
                <div class="d-flex justify-start">
                  <div class="card-logo pr-5">
                    <img src="@/assets/passport-banner/attendees.png" height="100" alt="">
                  </div>
                  <div class="card-left-details">
                    <h2 class="primary--text">ATTENDEE</h2>
                    <div class="primary--text">REGISTRATION</div>
                    <div class="text-xs gold--text">Discover Weddings, Travel & Celebrations</div>
                    <div class="d-flex justify-space-between mt-3 gap-x-15 detail-icons">
                      <div class="text-center">
                        <div><v-icon>mdi-ring</v-icon></div>
                        <div class="text-xs">Weddings</div>
                      </div>
                      <div class="text-center">
                        <div><v-icon>mdi-airplane</v-icon></div>
                        <div class="text-xs">Travel</div>
                      </div>
                      <div class="text-center">
                        <div><v-icon>mdi-party-popper</v-icon></div>
                        <div class="text-xs">Celebrations</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 text-center">
                  <v-btn rounded color="primary" block :to="{name : 'EventRegistration'}">register as attendee <v-icon>mdi-chevron-right</v-icon></v-btn>
                  <p class="primary--text text-xs mt-2">For soon-to-wed couples, families, entourage, travelers, and event planners.</p>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="pa-5">
                <div class="d-flex justify-start">
                  <div class="card-logo pr-5">
                    <img src="@/assets/passport-banner/exhibitor.png" height="100" alt="">
                  </div>
                  <div class="card-left-details">
                    <h2 class="gold--text">EXHIBITOR</h2>
                    <div class="gold--text">REGISTRATION</div>
                    <div class="text-xs gold--text">Promote Your Business & Connect with Qualified Clients</div>
                    <div class="d-flex justify-space-between mt-3 gap-x-15 detail-icons">
                      <div class="text-center">
                        <div><v-icon>mdi-account-multiple</v-icon></div>
                        <div class="text-xs">Generate Leads</div>
                      </div>
                      <div class="text-center">
                        <div><v-icon>mdi-calendar-outline</v-icon></div>
                        <div class="text-xs">Direct Booking</div>
                      </div>
                      <div class="text-center">
                        <div><v-icon>mdi-bullhorn-outline</v-icon></div>
                        <div class="text-xs">Brand Exposure</div>
                      </div>
                      <div class="text-center">
                        <div><v-icon>mdi-finance</v-icon></div>
                        <div class="text-xs">Business Growth</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 text-center">
                  <v-btn rounded color="gold" block dark :to="{name : 'ExhibitorRegistration'}">register as exhibitor <v-icon>mdi-chevron-right</v-icon></v-btn>
                  <p class="gold--text text-xs mt-2">For wedding suppliers, venues, hotels, travel agencies, event providers, and brands.</p>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <!-- STEP FORM -->

      <FooterTwo />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import { utilsMixin } from '@/composables/utils';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import FooterTwo from '../components/FooterTwo.vue';
export default {
  name: "PassportMainPage",
  mixins: [utilsMixin],
  components: { Header, Footer, FooterTwo },
  data() {
    return {
      activeEvents : [],
      event: {
        date: 'October 17-118 2026',
        location: 'Megatrade Hall, SM Megamall'
      }
    }
  },
  async mounted() {
      try {
          let response = await axios({
              url: process.env.VUE_APP_API_URL + '/active-events',
              method: 'GET'
          });

          this.activeEvents = response.data;
          if (this.activeEvents.length > 0) {
              this.event = this.activeEvents[0];
              console.log(this.event)
          }
      } catch (error) {
          console.log(error);
      }
  },
};
</script>
<style scoped>
.detail-icons {
  visibility: visible;
}
@media (max-width: 480px) {
  .detail-icons {
    visibility: hidden;
    width: 0px;
    height: 0px;
  }
}
</style>
